import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'
import { Formik } from 'formik'
import * as Yup from 'yup'

import setSelectReimburseAnotherEmployersPlan from 'core/application/adminDashboard/benefitDetails/design/qsehra/productClass/setSelectReimburseAnotherEmployersPlan'

import Radio from 'common/components/dataEntry/formik/FormikRadioField'
import Alert from 'common/components/feedback/Alert'

import useCommandRequest from 'common/hooks/useCommandRequest'

import { BaseComponentProps } from '../../../../../common/productClassWizardModal/Common'

export type SetReimburseAnotherEmployersPlanProps = {
  productClassId: string
  reimburseAnotherEmployersPlan: boolean
}

const SetReimburseAnotherEmployersPlan = (props: BaseComponentProps<SetReimburseAnotherEmployersPlanProps>) => {
  const { t: translate } = useTranslation()

  const { bindSubmitFormHandler } = props
  const [sendCommand] = useCommandRequest()
  const [initialValues] = useState<SetReimburseAnotherEmployersPlanProps>({
    productClassId: props.state.productClassId,
    reimburseAnotherEmployersPlan: props.state.reimburseAnotherEmployersPlan,
  })

  const onSubmit = async (values: any) => {
    const request = {
      productClassId: props.state.productClassId,
      reimburseAnotherEmployersPlan: values.reimburseAnotherEmployersPlan,
    }

    const result = await sendCommand(() => setSelectReimburseAnotherEmployersPlan(request))

    if (result.completed) {
      props.goNext()
    } else {
      props.setIsSubmiting(false)
    }
  }

  useEffect(() => {
    props.setIsFormValid(formValidator(translate).isValidSync(initialValues))
  }, [initialValues])

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={Yup.object({})}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={(values) => {
        const isValid: boolean = formValidator(translate).isValidSync(values)
        props.setHasDirtyData(isValid)
        props.setIsFormValid(isValid)
        return {}
      }}
    >
      {(formik) => {
        const { handleSubmit, submitForm } = formik
        bindSubmitFormHandler(submitForm)
        return (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <Row>
              <Col span={24}>
                <h5 className="select_class_info mb-24">
                  {translate('admin-dashboard.benefit-details.qsehra-benefit-design-step-2.header')}
                </h5>
              </Col>
            </Row>

            <div>
              <Alert
                showIcon
                type="info"
                className={'mb-24'}
                message={''}
                description={
                  <>
                    <p className="mb-0">
                      {translate('admin-dashboard.benefit-details.qsehra-benefit-design-step-2.alert-step-2')}
                    </p>
                    <a
                      className="ant-btn ant-btn-link p-0"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://peoplekeephelp.zendesk.com/hc/en-us/articles/360059187673-Tax-Treatment-of-QSEHRA-Reimbursements"
                    >
                      {translate('general.learn-more')}
                    </a>
                  </>
                }
              />
            </div>

            <Radio.Group
              name="reimburseAnotherEmployersPlan"
              className="w-100 qsehra-benefit-design-radio-group"
              defaultValue={initialValues.reimburseAnotherEmployersPlan}
            >
              <Row gutter={10}>
                <Col span={24} className={'mb-8'}>
                  <Radio.Button value={true}>Yes, reimburse</Radio.Button>
                </Col>
                <Col span={24} className={'mb-8'}>
                  <Radio.Button value={false}>No</Radio.Button>
                </Col>
              </Row>
            </Radio.Group>
          </form>
        )
      }}
    </Formik>
  )
}

export default SetReimburseAnotherEmployersPlan

const formValidator = (translate: any) =>
  Yup.object({
    reimburseAnotherEmployersPlan: Yup.boolean().required(translate('general.required')),
  })
